import isObject from "../struct-events/is-object.js";
import Tracker from "../prop-trackers/tracker.js";
import ValueTracker from "../prop-trackers/value-tracker.js";
import SinglePropTracker from "../prop-trackers/single-prop-tracker.js";

/*
 * TODO: optimize by reusing existing trackers in .track
 */

class SinglePropChainTracker extends Tracker {
    constructor(evtCtx, userdata) {
        super();

        this._evtCtx = evtCtx;

        this._propTrackers = [];
        this._key = [];
        this._valueTracker = new ValueTracker(userdata);

        this._needsUpdateThis = () => this.protected_needsUpdate();
    }

    track(object, key) {
        if (object && key.length === 0) {
            throw new Error("Key of length 0 given");
        }

        for (const tracker of this._propTrackers) {
            tracker.track();
            tracker.unlistenNeedsUpdate(this._needsUpdateThis);
        }

        this._propTrackers.length = 0;
        this._key.length = 0;

        if (object) {
            for (const segment of key) {
                const tracker = new SinglePropTracker();
                tracker.listenNeedsUpdate(this._needsUpdateThis);

                this._propTrackers.push(tracker);
                this._key.push(segment);
            }

            const events = this._evtCtx.getEvents(object);
            this._propTrackers[0].track(object, events, key[0]);
        }

        this._valueTracker.deleteValue();
        this.protected_needsUpdate();
    }

    protected_startUpdate() {
        if (this._propTrackers.length !== 0) {
            const lastIndex = this._propTrackers.length-1;

            for (let i0 = 0; i0 < lastIndex; i0++) {
                const tracker = this._propTrackers[i0];

                if (tracker.needsUpdate) {
                    tracker.update(({ prop: { newValue } }) => {
                        const i1 = i0+1;

                        const nextTracker = this._propTrackers[i1];
                        const nextKey = this._key[i1];

                        const newValueEvents = isObject(newValue) ? this._evtCtx.getEvents(newValue) : null;
                        nextTracker.track(newValue, newValueEvents, nextKey);
                    });
                }
            }

            const lastPropTracker = this._propTrackers[lastIndex];

            if (lastPropTracker.needsUpdate) {
                lastPropTracker.update(({ prop: { newExists, newValue } }) => {
                    if (newExists) {
                        this._valueTracker.setValue(newValue);
                    } else {
                        this._valueTracker.deleteValue();
                    }
                });
            }
        }

        return this._valueTracker.startUpdate();
    }

    protected_finishUpdate() {
       this._valueTracker.finishUpdate();
    }
}

export default SinglePropChainTracker;
